import { AbstractControl, ValidatorFn, AsyncValidatorFn, ValidationErrors, FormArray } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UniversityPerson } from '../models';
import { PersonService } from '../services';
import { of } from 'rxjs';

export class PersonValidator {
    public static isActive = (personService: PersonService): AsyncValidatorFn => {
        return (control: AbstractControl): Observable<ValidationErrors | null> => {
            if (control.value == null) {
                return of(null);
            }
            return personService.isActive(control.value.univId).pipe(
                map(isActive => {
                    return isActive ? control.errors : { isActive: true };
                })
            );
        }
    }

    public static hasPersonCompletedCashHandlingTraining = (personService: PersonService): AsyncValidatorFn => {
        return (control: AbstractControl): Observable<ValidationErrors | null> => {
            return personService.hasPersonCompletedCashHandlingTraining(control.value.univId).pipe(
                map(isActive => {
                    return isActive ? control.errors : { hasPersonCompletedCashHandlingTraining: true };
                })
            );
        }
    }

    public static isUnique = (): ValidatorFn => {
        return (formArray: FormArray): { [key: string]: boolean } => {
            const controls: AbstractControl[] = formArray.controls.filter((control: AbstractControl) => {
                return control.value != null;
            });
            const uniqueObj: any = { unique: true };
            let find: boolean = false;

            if (controls.length > 0) {
                controls.forEach(x => {
                    if (x.errors) {
                        delete x.errors['unique'];
                        if (Object.keys(x.errors).length === 0) {
                            x.setErrors(null);
                        }
                    }
                });
                for (let i: number = 0; i < controls.length; i++) {
                    const mainControl: AbstractControl = controls[i];
                    const val: UniversityPerson = mainControl.value;
                    const mainValue: UniversityPerson = val;
                    controls.forEach((control: AbstractControl, index: number) => {
                        if (i === index) {
                            return;
                        }
                        const tempValue: UniversityPerson = control.value;
                        const currValue: UniversityPerson = tempValue;

                        let newErrors: any;

                        if (mainValue.univId === currValue.univId) {
                            if (control.errors == null) {
                                newErrors = uniqueObj;
                            } else {
                                newErrors = Object.assign(control.errors, uniqueObj);
                            }
                            control.setErrors(newErrors);
                            find = true;
                        }
                    });
                }
                if (find) {
                    return uniqueObj;
                }
            }
            return null;
        };
    }
}